import Show from '../show'

function UbBillingDashboard() {
  return (
    <Show
      title="Utility Billing — Billing Dashboard"
      dashboardKey="ub_billing_dashboards"
      showYear={false}
    />
  )
}

export default UbBillingDashboard
